import {StyleSheet} from 'react-native';
import {
  BASESTYLE,
  COLORS,
  FixedValue,
  FONT_NAMES,
  GlobalStyleValues,
  Percentage,
} from '../../../constants';
import {IColorTheme} from '../../../types/contextTypes/themeContext';
import {
  normalizeFont,
  scaleHeight,
  scaleWidth,
} from '../../../utils/responsive';

export const styles = (theme: IColorTheme) =>
  StyleSheet.create({
    containerView: {
      ...BASESTYLE.inRow,
      ...BASESTYLE.spaceBetween,
      width: Percentage.PRECENTAGE_100,
      paddingLeft: scaleWidth(FixedValue.CONSTANT_VALUE_12),
      paddingRight: scaleWidth(FixedValue.CONSTANT_VALUE_14),
    },
    infoView: {
      ...BASESTYLE.column,
      width: Percentage.PRECENTAGE_70,
      marginTop: scaleHeight(-FixedValue.CONSTANT_VALUE_20),
    },
    groupNameText: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: theme?.color,
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_19),
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_6),
    },
    imageView: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      width: scaleWidth(FixedValue.CONSTANT_VALUE_48),
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_65),
      marginRight: scaleWidth(FixedValue.CONSTANT_VALUE_10),
    },
    placeHolderBackgroundColor: {
      backgroundColor: theme?.color,
    },
    countUserStyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      fontFamily: FONT_NAMES.SF_BOLD,
      color: theme?.color,
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_17),
      marginRight: scaleWidth(FixedValue.CONSTANT_VALUE_7),
    },
    groupNameStyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: theme?.color,
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_19),
      width: scaleWidth(FixedValue.CONSTANT_VALUE_161),
      textTransform: GlobalStyleValues.CAPITALIZE,
    },
    dateTextStyle: {
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_4),
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_12),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: COLORS._GREY,
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_14),
    },
    groupProfileText: {
      textAlign: GlobalStyleValues.CENTER,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_19),
      color: theme?.backgroundColor,
      fontFamily: FONT_NAMES.SF_MEDIUM,
      textTransform: GlobalStyleValues.UPPERCASE,
    },
    imageStyle: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      width: scaleWidth(FixedValue.CONSTANT_VALUE_48),
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_65),
    },
    createdDate: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_12),
      fontFamily: FONT_NAMES.SF_BOLD,
      color: theme?.color,
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_14),
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_4),
    },
    quantityText: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_12),
      fontFamily: FONT_NAMES.SF_BOLD,
      color: theme?.color,
      lineHeight: scaleHeight(FixedValue.CONSTANT_VALUE_12),
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_4),
    },
  });
